import { anonymousClient } from './util'
import { HTTP_SUCCESS } from '../helpers/utils/http-status'

const fetchTrainingProviders = async () => {
    return anonymousClient()
        .get(
            `/api/training-provider`,
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not retrieve training provider`)
            }
            return res
        }).then(res => res.data)
}

export {
    fetchTrainingProviders,
}